export const monitor = [
{
    path: '/unit-monitoring',
    name: 'Monitor',
    component: () => import('./Monitoring.vue'),
    meta: {
      rule: 'UNITS',
      autoRequired: true,
      title: 'general.unitMonitoring',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/'
        },
        {
          text: 'general.unitMonitoring',
          disabled: true,
          href: '#/unit-monitoring'
        }
      ]
    }
  },
  {
    path: '/damage-report',
    name: 'DamageReport',
    component: () => import('./damageReport/DamageReport.vue'),
    meta: {
      rule: 'UNITS',
      autoRequired: true,
      title: 'general.damageReport',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/'
        },
        {
          text: 'general.unitMonitoring',
          disabled: false,
          href: '#/unit-monitoring'
        },
        {
          text: 'general.damageReport',
          disabled: true,
          href: '#/damage-report'
        }
      ]
    }
  }
]